import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './app/App'
import { initRouter } from './app/router'
import { watchForUpdates } from './app/swUpdate'
import { useToast } from './app/toast'
import { t } from './strings/en'
import './styles/app.css'
import './styles/screens.css'
import './styles/chrome.css'
import './styles/tripsetup.css'

initRouter({ onExitHint: () => useToast.getState().show(t.backAgain) })
watchForUpdates()

const root = document.getElementById('root')
if (!root) throw new Error('#root missing')

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
